// extracted by mini-css-extract-plugin
export var ctaGroup = "TextSliderSection-module--ctaGroup--b08c4";
export var ctaHolder = "TextSliderSection-module--ctaHolder--8ba21";
export var navigator = "TextSliderSection-module--navigator--fea64";
export var navigatorActive = "TextSliderSection-module--navigatorActive--0e8e3";
export var title = "TextSliderSection-module--title--3d4eb";
export var wrapper = "TextSliderSection-module--wrapper--89971";
export var x = "TextSliderSection-module--x--0da65";